import { Button, BUTTON } from 'components/common/Button/Button';
const { SIZE, COLOR, BGCOLOR } = BUTTON;

import styles from './IndexDocumentDownloadOptions.scss';

export default function IndexDocumentDownloadOptions({
    document,
    documentDownloadRequest,
}){
    return <Button
        text="Download Source"
        onClick={() => documentDownloadRequest(document.id, null, 'ORIGINAL')}
        className={styles.indexDocumentDownloadOptions}
        type={SIZE.PRIMARY}
        color={COLOR.WHITE}
        bgcolor={BGCOLOR.BLUE}
        data-cy="IndexDocumentDownloadOptionsBtn"/>;

}
